module.exports = __webpack_public_path__ + "static/media/hero-urbano.1b737ef2.png";